import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import {
	ConfirmDialogData,
	ConfirmComponent
} from "@modules/+new/shared/universal-modal/components/_presets/confirm/confirm.component";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";

export const ConfirmPresetDefinition: OpenPresetModalDefinition<ConfirmDialogData> = {
	component: ConfirmComponent,
	options: {
		allowBackdropCancel: false,
		clearPathOnOpen: true,
		wrap: false,
		extraClass: ["large-gutter", "no-min-height"],
		isPreset: PresetsComponentsEnum.confirm,
		goBackOnEscKey: true
	}
};
